.pf-c-card__title {
    --pf-c-card__title--FontFamily: var(--pf-global--FontFamily--heading--sans-serif);
    --pf-c-card__title--FontSize: var(--pf-global--FontSize--md);
    --pf-c-card__title--FontWeight: var(--pf-global--FontWeight--bold);
}

[part="table-container"] {
    overflow-x: auto;
}
